module.exports = __webpack_public_path__ + "img/pahala.8bcba520.png";